declare global {
  interface OC {
    getClientCode: () => Promise<string>;
    getPassword: () => Promise<string>;
    getUsername: () => Promise<string | undefined>;
    getEmail: () => Promise<string>;
    getVersion: () => Promise<string>;
    getModules: () => Promise<string[]>;
    getDebug: () => Promise<boolean>;

    startProgram: (progam: string, args?: string[]) => Promise<void>;
    openDevTools: () => Promise<void>;
  }

  interface Window {
    CefSharp: any;
    oc: OC;
  }
}

export class OfficeCompanionService {
  initialise = async () => {
    if (window.oc === undefined && window.CefSharp !== undefined) {
      await window.CefSharp.BindObjectAsync("oc");
    }
  }

  getClientCode = async (): Promise<string> => {
    await this.initialise();
    try {
      const code = await window.oc.getClientCode();

      return code;
    } catch (ex) {
      console.log('No OC service');
    }

    return 'DUMMY';
  }

  getPassword = async () => {
    await this.initialise();
    try {
      const password = await window.oc.getPassword();

      return password;
    } catch (ex) {
      console.log('No OC service');
    }

    return '';
  }

  getUsername = async () => {
    await this.initialise();
    try {
      const username = await window.oc.getUsername();

      return username;
    } catch (ex) {
      console.log('No OC service');
    }

    return undefined;
  }

  getEmail = async () => {
    await this.initialise();
    try {
      const email = await window.oc.getEmail();

      return email;
    } catch (ex) {
      console.log('No OC service');
    }

    return '';
  }

  getVersion = async () => {
    await this.initialise();
    try {
      const version = await window.oc.getVersion();

      return version;
    } catch (ex) {
      console.log('No OC service');
    }
  }

  getModules = async () => {
    await this.initialise();
    try {
      const modules = await window.oc.getModules();

      return modules;
    } catch (ex) {
      console.log('No OC service');
    }

    return [];
  }

  getDebug = async () => {
    await this.initialise();
    try {
      const debug = await window.oc.getDebug();

      return debug;
    } catch (ex) {
      console.log('No OC Service');
    }

    return false;
  }

  startProgram = async (program: string, args?: string[]): Promise<void> => {
    await this.initialise();

    if (window.oc !== undefined) {
      await window.oc.startProgram(program, args);
    }
  }

  openDevTools = async (): Promise<void> => {
    await this.initialise();
    if (window.oc !== undefined) {
      await window.oc.openDevTools();
    }
  }
}
